<template>
  <base-status-page>
    <template v-slot:headertext="slotProps">
      <h1 class="display-2 text-white">{{ slotProps.website.name }}</h1>
      <span>
        <p class="text-white mt-0 mb-3">
          {{ greeting }}. Welcome to your dashboard.
          <br />
          Check here for updates on {{ slotProps.website.name }}'s service
          availability and performance.
          <br />
          <span v-if="slotProps.website.public" class="text-muted">
            Your status page is publicly accessible at:

            <router-link
              :to="{
                name: 'monitor',
                params: {
                  name: slotProps.website.website_url
                }
              }"
            >
              https://boltscale.io/status/{{ slotProps.website.website_url }}
            </router-link>
          </span>
        </p>
      </span>
    </template>
  </base-status-page>
</template>
<script>
import BaseStatusPage from "@/components/Custom/BaseStatusPage";

export default {
  components: {
    BaseStatusPage
  },
  data() {
    return {};
  },
  methods: {},
  async created() {},
  computed: {
    greeting() {
      const today = new Date();
      const curHr = today.getHours();

      if (curHr < 12) {
        return "Good morning";
      } else if (curHr < 18) {
        return "Good afternoon";
      } else {
        return "Good evening";
      }
    }
  }
};
</script>
<style></style>
